import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@core/auth/auth.service';
import { HabilitationService } from '@core/service/habilitation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccessEditComponent } from '../components/habilitation/access-edit-dialog.component';

@Component({
  standalone: true,
  template: `<span *ngIf="enableEdit()" class="inline-link">
    <a (click)="edit($event); (false)">
      <i class="bi bi-lock-fill"></i>
    </a>
  </span> `,
  imports: [CommonModule],
})
export class AccessEditActionComponent {
  service = inject(HabilitationService);
  enableEdit = this.service.enableEdit;
  private resource!: string;
  private module!: string;
  constructor(private modalService: NgbModal) {}

  edit(e: any) {
    e.stopPropagation();

    const modalRef = this.modalService.open(AccessEditComponent, {
      size: 'xl',
      backdrop: 'static',
      windowClass: 'modal show',
    });
    modalRef.componentInstance.habilitationParams = {
      ressourceCode: this.resource,
      module: this.module,
    };
  }

  setResource(resource: string, module: string) {
    this.resource = resource;
    this.module = module;
  }
}

@Directive({
  standalone: true,
  selector: '[hasAnyAccess]',
})
export class HasAnyAccessDirective {
  private accesses: string[] = [];
  private module: string = 'MDL_GENERAL';
  protected readonly templateRef = inject(TemplateRef<any>);
  protected readonly viewContainer = inject(ViewContainerRef);
  protected readonly authService = inject(AuthService);
  private readonly destroy: DestroyRef = inject(DestroyRef);

  @Input()
  set hasAnyAccess(value: string | string[] | undefined) {
    let accesses: string[];
    if (Array.isArray(value)) {
      accesses = value;
    } else {
      accesses = value ? [value] : [];
    }
    if (accesses.length) {
      this.accesses = accesses;
      this.updateView();
      this.authService
        .getProfile()
        .pipe(takeUntilDestroyed(this.destroy))
        .subscribe(() => this.updateView());
    } else {
      this.viewContainer.clear();
      this.renderComponent();
    }
  }

  @Input()
  set hasAnyAccessModule(module: string | undefined) {
    if (module) {
      this.module = module;
    }
  }

  private updateView(): void {
    this.viewContainer.clear();
    if (this.authService.hasAnyAccess(this.accesses)) {
      this.renderComponent();
    }
  }

  renderComponent() {
    if (this.accesses?.length) {
      const cmp = this.viewContainer.createComponent(AccessEditActionComponent);
      cmp.instance.setResource(this.accesses[0], this.module);
    }
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
